<template>
  <div class="app-error-placeholder">
    <p>Error loading application.</p>
    <p v-if="error && error.message">{{ error.message }}</p>
    <!-- You might want to log the full error object to the console or a logging service -->
  </div>
</template>

<script setup lang="ts">
// This component will receive an 'error' prop from defineAsyncComponent if loading fails
defineProps({
  error: Object
});
</script>

<style scoped>
.app-error-placeholder {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  padding: 20px;
  color: red;
  background-color: #ffe0e0;
  border: 1px solid red;
  border-radius: 5px;
}
.app-error-placeholder p {
  margin-bottom: 10px;
}
</style> 